<div class="container mt-5">

    <foehn-page-counter></foehn-page-counter>

    <foehn-form>
        <div class="row">
            <div class="col-md-8">
                <!--Origine de la demande-->
                <foehn-recap-section
                    [acceptEmptyValues]="true"
                    [data]="{
                        titleKey: 'request-origin.title',
                        elements: [
                            { key: 'request-origin.isSelfRequest.label', value: form.requestOrigin.isSelfRequest | displayBoolean },
                            { key: 'request-origin.initiator.label', value: form.requestOrigin.initiator?.valeur },
                            { key: 'request-origin.lastName.label', value: form.requestOrigin.lastName },
                            { key: 'request-origin.firstName.label', value: form.requestOrigin.firstName },
                            { key: 'request-origin.email.label', value: form.requestOrigin.email },
                            { key: 'request-origin.phone.label', value: form.requestOrigin.phone }
                        ]
                }"
                ></foehn-recap-section>

                <!-- Information sur le/la beneficiaire -->
                <foehn-recap-section
                    [acceptEmptyValues]="true"
                    [data]="{
                        titleKey: 'information-applicant.title',
                        elements: [
                            { key: 'information-applicant.avs.label', value: form.informationApplicant.avs },
                            { key: 'information-applicant.civility.label', value: form.informationApplicant.civility?.longDescription },
                            { key: 'information-applicant.lastName.label', value: form.informationApplicant.lastName },
                            { key: 'information-applicant.firstName.label', value: form.informationApplicant.firstName },
                            { key: 'information-applicant.birthDate.label', value: form.informationApplicant.birthDate | displayDate },
                            { key: 'information-applicant.nationality.label', value: form.informationApplicant.nationality?.shortNameFr },
                            { key: 'information-applicant.dateOfArrival.label', value: form.informationApplicant.dateOfArrival},
                            { key: 'information-applicant.residencePermit.label', value: form.informationApplicant.residencePermit?.valeur },
                            { key: 'information-applicant.address.label', value: form.informationApplicant.address },
                            { key: 'information-applicant.email.label', value: form.informationApplicant.email },
                            { key: 'information-applicant.phone.label', value: form.informationApplicant.phone },
                            { key: 'information-applicant.contactPreference.label', value: form.informationApplicant.contactPreference?.valeur }
                        ]
                }"
                ></foehn-recap-section>

                <!--------------------------------Projet pro-------------------------------->
                <foehn-recap-section
                    [acceptEmptyValues]="true"
                    [data]="{
                        titleKey: 'professional-project.title',
                        elements: [
                            { key: 'career-applicant.situation.label', value: form.requestOrigin.situation?.valeur },
                            { key: 'career-applicant.levelOfEducation.label', value: form.careerApplicant.levelOfEducation?.valeur },
                            { key: 'professional-project.projectType.label', value: form.professionalProject.projectType?.valeur },
                            { key: 'professional-project.intendedProfession.label', value: form.professionalProject.intendedProfession },
                            { key: 'professional-project.specialization.label', value: form.professionalProject.specialization },
                            { key: 'professional-project.comment.label', value: form.professionalProject.comment }
                        ]
                }"
                ></foehn-recap-section>

                <!-- Personne de reference-->
                <foehn-recap-section
                    *ngIf="!(informationApplicantService.isApplicantAdult())"
                    [acceptEmptyValues]="true"
                    [data]="{
                        titleKey: 'legal-representative.title',
                        elements: [
                            { key: 'legal-representative.isLegalRepresentativeRequestInitiator.label', value: form.legalRepresentative.isLegalRepresentativeRequestInitiator | displayBoolean },
                            { key: 'legal-representative.relation.label', value: form.legalRepresentative.relation?.valeur },
                            { key: 'legal-representative.lastName.label', value: form.legalRepresentative.lastName },
                            { key: 'legal-representative.firstName.label', value: form.legalRepresentative.firstName },
                            { key: 'legal-representative.address.label', value: form.legalRepresentative.address },
                            { key: 'legal-representative.phone.label', value: form.legalRepresentative.phone },
                            { key: 'legal-representative.email.label', value: form.legalRepresentative.email }
                        ]
                }"
                ></foehn-recap-section>
                <!--------------------------------Personnes de référence-------------------------------->
                <div>
                    <span
                        style="font-size: 1.8em; margin-right: 15px">{{ 'personne.reference.page.title' | fromDictionary }}</span>
                </div>
                <ng-container>
                    <div *ngFor="let master of form.personnesReference.personnesReferences">
                        <foehn-recap-section
                            *ngFor="let item of filterItems(master)"
                            [acceptEmptyValues]="true"
                            [data]="{
                                titleKey: item.role?.valeur,
                                elements: [
                                        { key: 'personne.reference.page.contact.role.label', value: item.role?.valeur},
                                        { key: 'personne.reference.page.contact.nom.label', value: item.nom },
                                        { key: 'personne.reference.page.contact.prenom.label', value: item.prenom },
                                        { key: 'personne.reference.page.contact.address.label', value: item.adresse?.street ? item.adresse : ''},
                                        { key: 'personne.reference.page.contact.email.label', value: item.email },
                                        { key: 'personne.reference.page.contact.phone.label', value: item.telephone }
                                    ]
                                }"
                        ></foehn-recap-section>
                    </div>
                </ng-container>

                <foehn-recap-section
                    [acceptEmptyValues]="true"
                    [data]="{
                        titleKey: 'career-applicant.title',
                        elements: [
                            { key: 'career-applicant.situation.label', value: form.requestOrigin.situation?.valeur },
                            { key: 'career-applicant.levelOfEducation.label', value: form.careerApplicant.levelOfEducation?.valeur }
                        ]
                }"
                ></foehn-recap-section>

                <!--------------------------------Documents-------------------------------->
                <div>
                    <span style="font-size: 1.8em; margin-right: 15px">{{ 'attachments.title' | fromDictionary }}</span>
                </div>

                <ng-container *ngFor="let recapAttachment of form.attachments.recap">
                    <foehn-recap-section
                        [acceptEmptyValues]="true"
                        [data]="recapAttachment"
                    ></foehn-recap-section>
                </ng-container>
            </div>
        </div>

        <div class="row">
            <div class="col-md-8">

                <app-remaining-alerts-summary></app-remaining-alerts-summary>

                <foehn-navigation
                    (onNext)="sendAndTransmit()"
                    (onPrevious)="previous()"
                >
                </foehn-navigation>
            </div>
        </div>
    </foehn-form>
</div>
